import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { CtaBand } from './CtaBand';
import { PaperworkHanko, Spot } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { NextLink, ProductFaq, ProductHero, ProductSection } from './ProductParts';
import './product-email.css';
const CARDS = [
    {
        k: '壱 · Connect',
        title: 'Fastmail or any IMAP mailbox',
        text: 'Use Fastmail with an API token, or any email over IMAP (Gmail, iCloud, Yahoo, Zoho or your own host) with an app password. You can disconnect any time in Settings.'
    },
    {
        k: '弐 · Sends',
        title: 'Sheet requests and customer updates',
        text: 'Sheet requests go straight to your agent. Customer updates sit in the Outbox until you OK them, unless you’ve turned on auto-send.'
    },
    {
        k: '参 · Reads',
        title: 'Agent replies with sheets',
        text: 'When your agents reply to its requests, it reads the replies and files the sheets.'
    },
    {
        k: '四 · Links',
        title: 'Threads tied to the work',
        text: 'Each thread links to its hunt, car or customer, so you find the conversation right next to the car.'
    }
];
// Product tour 07. Design: design-mockups/rhd-woodblock/Product-Email.dc.html.
export default function ProductEmailPage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('email'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    k: "郵便",
                    label: "Product · 07 Email",
                    title: "Your own mailbox, drafts first.",
                    lead: "Connect Fastmail, or any email over IMAP, including Gmail, iCloud, Yahoo, Zoho and your own host. Sheet requests go out from your address and customer updates wait for your OK. When a reply brings a sheet, it lands on the right car.",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-pe-thread",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-pp-mock-head",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pe-thread__title",
                                        children: "Thread · linked to Lot 50981 and M. Okafor"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pp-mono-sm",
                                        children: "via Fastmail"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-pe-msg",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-pe-msg__head",
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                className: "mk-pe-msg__who",
                                                children: "You → your agent"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pe-msg__state mk-pe-msg__state--ok",
                                                children: "Sent · sheet request"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pe-msg__body",
                                        children: "Could you send the auction sheet for Lot 50981 (Land Cruiser, Thu)? Thanks."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-pe-msg mk-pe-msg--sheet",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-pe-msg__head",
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                className: "mk-pe-msg__who",
                                                children: "Agent → You"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pe-msg__state mk-pe-msg__state--amber",
                                                children: "Sheet found · read"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "mk-pe-file",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pe-file__k",
                                                children: "査"
                                            }),
                                            "sheet_50981.jpg → Grade 4"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-pe-msg mk-pe-msg--draft",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-pe-msg__head",
                                        children: [
                                            /*#__PURE__*/ _jsx("b", {
                                                className: "mk-pe-msg__who",
                                                children: "Draft · You → M. Okafor"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pe-msg__state mk-pe-msg__state--pill",
                                                children: "Waiting for your OK"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pe-msg__body",
                                        children: "Good news. The sheet on the Thursday Land Cruiser came back a 4, with a clean interior…"
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "mk-pe-btns",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pp-mini-btn",
                                                children: "Approve & send"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-pp-mini-btn mk-pp-mini-btn--ghost",
                                                children: "Edit"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 260,
                    children: /*#__PURE__*/ _jsx(PaperworkHanko, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    title: "What it sends and what it reads.",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "mk-pe-cards",
                        children: CARDS.map((c)=>/*#__PURE__*/ _jsxs("div", {
                                className: "mk-pe-card",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-pe-card__k",
                                        children: c.k
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "mk-pe-card__title",
                                        children: c.title
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mk-pe-card__text",
                                        children: c.text
                                    })
                                ]
                            }, c.k))
                    })
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    tightTop: true,
                    title: "Email questions",
                    items: [
                        [
                            'Can it read my whole inbox?',
                            'No. It only reads threads tied to your hunts, cars, customers and agents.'
                        ],
                        [
                            'Outlook or other providers?',
                            'Fastmail, or any email over IMAP, such as Gmail, iCloud, Yahoo, Zoho or your own host. Outlook and Microsoft 365 aren’t supported yet.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next",
                    title: "The importing guide",
                    go: "案内 →",
                    href: MKT.guide
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
